import styles from './Question.module.scss'

import PropTypes from 'prop-types'
import React from 'react'
import Button from './Button'

const Question = ({ question, onAnswerPick }) => (
  <div className={styles.wrapper}>
    <h2>{question.title}</h2>
    <div className={styles.answers}>
      {question.answers.map((answer, i) => (
        <Button key={answer.title} onClick={() => onAnswerPick(i)}>
          {answer.title}
        </Button>
      ))}
    </div>
  </div>
)

Question.propTypes = {
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    answers: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
  onAnswerPick: PropTypes.func.isRequired,
}

export default Question
